/*=========================================================================================
  File Name: moduleWarehouseGetters.js
  Description: Warehouse Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

export default {};
